import { ZeroHash } from "ethers";
import { diffAnnotations } from "./annotations";
import { diffMembers } from "./members";
import { diffTargets } from "./target";
import { merge } from "./helpers";
export function diffRoles({ prev, next, }) {
    const roleKeys = Array.from(new Set([
        ...(prev?.map(({ key }) => key) || []),
        ...(next?.map(({ key }) => key) || []),
    ]));
    return roleKeys
        .map((roleKey) => diffRole({
        prev: prev?.find(({ key }) => key == roleKey),
        next: next?.find(({ key }) => key == roleKey),
    }))
        .reduce(merge, { minus: [], plus: [] });
}
export function diffRole({ prev, next, }) {
    const roleKey = ensureRoleKey(prev, next);
    return [
        diffMembers({
            roleKey,
            prev: prev?.members,
            next: next?.members,
        }),
        diffTargets({
            roleKey,
            prev: prev?.targets,
            next: next?.targets,
        }),
        diffAnnotations({
            roleKey,
            prev: prev?.annotations,
            next: next?.annotations,
        }),
    ].reduce((p, n) => merge(p, n), { minus: [], plus: [] });
}
function ensureRoleKey(prev, next) {
    const set = new Set([prev?.key, next?.key].filter(Boolean));
    if (set.size >= 2) {
        throw new Error(`Not the same Role: ${prev?.key} and ${next?.key}`);
    }
    return prev?.key || next?.key || ZeroHash;
}
